import gql from 'graphql-tag';

export default gql`
mutation updateForm($obj: updateFormInput!) {
  updateForm(object: $obj) {
    updatedForm
  }
}
`;
